import { atom } from "recoil";

export const sliderBoxUpdate = atom({
  key: "update-box-slider",
  default: {},
});

export const ContentUnitModal = atom({
  key: "toggle-modal-flag",
  default: {
    deletCategory: {
      isShow: false,
      value: {},
    },
    updateCategory: {
      isShow: false,
      value: {},
    },
    deleteAskQuestion: {
      isShow: false,
      value: {},
    },
    updateAskQuestion: {
      isShow: false,
      value: {},
    },
    deleteProperty: {
      isShow: false,
      value: {},
    },
    updateProperty: {
      isShow: false,
      value: {},
    },
    deletePropertyLevel2: {
      value: {},
      isShow: false,
    },
    updatePropertyLevel2: {
      value: {},
      isShow: false,
    },
    deleteCountry: {
      value: {},
      isShow: false,
    },
    updateCountry: {
      value: {},
      isShow: false,
    },
    deleteProvince: {
      value: {},
      isShow: false,
    },
    updateProvince: {
      value: {},
      isShow: false,
    },
    deleteCity: {
      value: {},
      isShow: false,
    },
    updateCity: {
      value: {},
      isShow: false,
    },
    deleteArea: {
      value: {},
      isShow: false,
    },
    updateArea: {
      value: {},
      isShow: false,
    },
    deleteLevel1: {
      value: {},
      isShow: false,
    },
    updateLevel1: {
      value: {},
      isShow: false,
    },
    deleteLevel2: {
      value: {},
      isShow: false,
    },
    updateLevel2: {
      value: {},
      isShow: false,
    },
    deleteLevel3: {
      value: {},
      isShow: false,
    },
    updateLevel3: {
      value: {},
      isShow: false,
    },
    deleteBrand: {
      value: {},
      isShow: false,
    },
    updateBrand: {
      value: {},
      isShow: false,
    },
    deleteGender: {
      value: {},
      isShow: false,
    },
    updateGender: {
      value: {},
      isShow: false,
    },
    deleteOccation: {
      value: {},
      isShow: false,
    },
    updateOccation: {
      value: {},
      isShow: false,
    },
  },
});

export const CategoryList = atom({
  key: "category-list-item",
  default: [],
});

export const RefreshTable = atom({
  key: "update-Table",
  default: false,
});

export const RefreshTableAskQuestion = atom({
  key: "update-table-ask-question",
  default: false,
});

export const RefreshTableLevelFirst = atom({
  key: "update-table-product-property-level1",
  default: false,
});

export const RefreshTableLevelSecond = atom({
  key: "update-table-product-property-level2",
  default: false,
});

export const RefreshTableNotif = atom({
  key: "update-table-notification",
  default: false,
});

// area coverd

export const RefreshTableCountry = atom({
  key: "update-table-country",
  default: false,
});

export const RefreshTableProvince = atom({
  key: "update-table-province",
  default: false,
});

export const RefreshTableCity = atom({
  key: "update-table-city",
  default: false,
});

export const RefreshTableArea = atom({
  key: "update-table-area",
  default: false,
});

// product category

export const RefreshTableLevel1 = atom({
  key: "update-table-category-product-level_first",
  default: false,
});

export const RefreshTableLevel2 = atom({
  key: "update-table-category-product-level_two",
  default: false,
});

export const RefreshTableLevel3 = atom({
  key: "update-table-category-product-level_three",
  default: false,
});

export const RefreshTableOccation = atom({
  key: "update-Occation",
  default: false,
});

export const RefreshTableBrand = atom({
  key: "update-Brand",
  default: false,
});

export const RefreshTableGender = atom({
  key: "update-Gender",
  default: false,
});

export const RefreshTablContent = atom({
  key: "update-contents-blog",
  default: false,
});

export const RefreshTableBlog = atom({
  key: "update-blog-table",
  default: false,
});

export const EditContentState = atom({
  key: "edit-content",
  default: {},
});
